/* Wishlist section: renders the saved products (assets/wishlist.js) as theme product cards. */
(() => {
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cache = new Map();

  const fetchCard = (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    const p = fetch(`${root()}products/${encodeURIComponent(handle)}?section_id=wishlist-grid`)
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => {
        if (!html) return null;
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nt-wishlist-card]');
        return el ? el.outerHTML : null;
      })
      .catch(() => null);
    cache.set(handle, p);
    return p;
  };

  const paintMeta = (section, count) => {
    const empty = section.querySelector('[data-nt-wl-empty]');
    if (empty) empty.hidden = count > 0;
    const c = section.querySelector('[data-nt-wl-count]');
    if (c) {
      const tpl = count === 1 ? c.dataset.one : c.dataset.many;
      c.textContent = (tpl || '').replace('[count]', count);
      c.hidden = count === 0 || !tpl;
    }
  };

  const render = async (section) => {
    const list = section.querySelector('[data-nt-wl-items]');
    if (!list || !window.ntWishlist) return;
    const handles = window.ntWishlist.get();
    list.setAttribute('aria-busy', 'true');
    const cards = await Promise.all(handles.map(fetchCard));
    const frag = document.createDocumentFragment();
    let shown = 0;
    cards.forEach((html) => {
      if (!html) return;
      const li = document.createElement('li');
      li.innerHTML = html;
      frag.appendChild(li);
      shown += 1;
    });
    list.replaceChildren(frag);
    list.setAttribute('aria-busy', 'false');
    paintMeta(section, shown);
    window.ntWishlist.sync(section);
  };

  const removeCard = (section, handle) => {
    const card = section.querySelector(`[data-nt-wishlist-card][data-handle="${CSS.escape(handle)}"]`);
    if (card) card.closest('li').remove();
    paintMeta(section, section.querySelectorAll('[data-nt-wishlist-card]').length);
  };

  const init = (scope = document) => scope.querySelectorAll('[data-nt-wishlist-grid]').forEach(render);
  const start = () => {
    init();
    document.addEventListener('nt:wishlist:change', (e) => {
      document.querySelectorAll('[data-nt-wishlist-grid]').forEach((section) => {
        const d = e.detail || {};
        if (d.handle && d.added === false) removeCard(section, d.handle);
        else render(section);
      });
    });
  };
  // wishlist.js is loaded just before this file (both deferred), so ntWishlist exists by now.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
